import React from 'react';
import { HowToPlayModal } from '../../components/HowToPlayModal/HowToPlayModal';
import { crosswordAllWordsBonus } from './crosswordUtils';

export function HowToPlay({ onClose }) {
  return (
    <HowToPlayModal title="How to Play" titleId="crossword-how-title" onClose={onClose}>
      <p className="how-to-play-intro">
        Find <strong>hidden words</strong> in straight lines — <strong>across</strong>, <strong>down</strong>, or{' '}
        <strong>diagonal</strong>. Words read <strong>forward or backward</strong> along the line and are{' '}
        <strong>4–8 letters</strong>.
      </p>
      <p className="how-to-play-intro">
        <strong>Tap</strong> letters one at a time along a single straight line. After the first letter, each step must go
        to a <strong>neighbor</strong> in the same direction — no gaps or turns. Tap a cell that doesn&apos;t continue
        the line to start a new path there.
      </p>
      <p className="how-to-play-intro">
        Tap <strong>Submit word</strong> when your selection matches a hidden word. Use <strong>Clear</strong> to reset;
        tap the last letter again to undo one step.
      </p>
      <p className="how-to-play-intro">
        The daily puzzle is <strong>8×8</strong> and the same for everyone (local calendar day). You have{' '}
        <strong>three hints per puzzle</strong>: each picks a random unfound word and highlights its letters on the
        grid until you solve it — words found after a hint earn <strong>half points</strong> (floored),
        minimum <strong>5</strong>. Otherwise earn <strong>5 points per letter</strong>, plus a{' '}
        <strong>{crosswordAllWordsBonus()}-point bonus</strong> when you find every word. Stars reflect your score;
        use <strong>Submit Score</strong> when you&apos;re done!
      </p>
    </HowToPlayModal>
  );
}
